import { Link } from "react-router-dom";

export function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <section className="footer-top-wrap">
        <div className="container">
          <div className="row">
            <div className="single-item col-lg-3 col-md-6 col-12">
              <div className="footer-box">
                <div className="footer-header">
                  <h3>About Info</h3>
                </div>
                <div className="footer-about">
                  <p>
                    Our range of pharmaceutical drugs is formulated in
                    compliance with GMP & WHO standards and norms. Further, our
                    quality management system regularly checks the formulations
                    in order to increase their efficiency.
                  </p>
                </div>
              </div>
            </div>

            <div className="single-item col-lg-3 col-md-6 col-12">
              <div className="footer-box">
                <div className="footer-header">
                  <h3>Facility</h3>
                </div>
                <div className="footer-departments">
                  <ul>
                    <li>
                      <Link to="manufacturing">Manufacturing</Link>
                    </li>
                    <li>
                      <Link to="api">API Manufacturing</Link>
                    </li>
                    <li>
                      <Link to="research-development">R & D</Link>
                    </li>
                    <li>
                      <Link to="analytical-development">
                        Analytical Development
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="single-item col-lg-3 col-md-6 col-12">
              <div className="footer-box">
                <div className="footer-header">
                  <h3>Products</h3>
                </div>
                <div className="footer-departments">
                  <ul>
                    <li>
                      <Link to="pipeline">Products Under Pipeline</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="single-item col-lg-3 col-md-6 col-12">
              <div className="footer-box">
                <div className="footer-header">
                  <h3>Reach Us</h3>
                </div>
                <div className="footer-contact-info">
                  <ul>
                    <li>
                      <i className="bi bi-geo-alt"></i>Plot No. C-251, Saykha
                      GIDC Estate, Taluka : Vagara, District: Bharuch-392140,
                      Gujarat, India.
                    </li>
                    <li>
                      <i className="bi bi-envelope"></i> info@krufrenpharma.com
                    </li>
                    <li>
                      <Link
                        to="https://maps.app.goo.gl/BMgMgCLbLqezjnQ78"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#fff" }}
                      >
                        <i className="bi bi-globe"></i> Google Location
                      </Link>
                    </li>
                  </ul>
                  <div className="clearfix"></div>
                  {/* <div className="footer-social">
                    <ul>
                      <li style={{ margin: 0, padding: "0 14px" }}>
                        <Link to="/" target="_blank" style={{ padding: 0 }}>
                          <i className="fab fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li style={{ margin: 0, padding: "0 14px" }}>
                        <Link to="/" target="_blank" style={{ padding: 0 }}>
                          <i className="fab fa-twitter"></i>
                        </Link>
                      </li>
                      <li style={{ margin: 0, padding: "0 14px" }}>
                        <Link to="/" target="_blank" style={{ padding: 0 }}>
                          <i className="fab fa-linkedin-in"></i>
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="footer-bottom-wrap">
        <div className="container">
          <div className="row">
            <div className="copyright col-md-6" style={{ textAlign: "left" }}>
              Copyright @ {currentYear} Krufren Pharma Pvt Ltd. All Rights
              Reserved.
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}
